// @ts-nocheck
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
axios.defaults.timeout = 10000;
export const mainUrl = process.env.api;
// export const mainUrl = axios.defaults.baseURL = process.env.api;
import { getToken, setToken, removeToken, parseRemoteRoutes } from "@/utils/auth";
import {Dialog, Toast} from 'vant';
import UrlEncode from 'urlencode'
export const HTTP_IMG_URL = "https://ggypupload.oss-cn-shanghai.aliyuncs.com/hani/data/upload/miniimg/"
import router from "../router";
import store from '../store';
let localUrl = location.origin;
let getHomeUrl = localUrl+'/';
export const homeUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx884fad7e2cebff9e&redirect_uri='+UrlEncode(getHomeUrl)+'&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect'

//发送拦截
axios.interceptors.request.use(
  config => {
    config.headers.token = getToken();
    var items=uuidv4().split("-")
    var traceId =  items.join("")
    config.headers.traceId = traceId
    // let url = config.url;
    // if(url.indexOf('miniQR')>0){
    //   config.headers.token = token;
    // }else{
    //   config.headers.token = token_list;
    // }
    return config;
  }, err => {
    return Promise.reject(err);
  }
);
//接收拦截
axios.interceptors.response.use(
  response => {
    if (response.status == 200) {
      if(response.data.code&&response.data.code=='toke_expire'){
        console.log(store.state.routeNow)
        removeToken()
        store.commit('SET_TOKEN', '')
        router.replace({
          name: store.state.routeNow.name,
          query: {...store.state.routeNow.query,corpId:'$CORPID$'}
        })
      }
      return Promise.resolve(response);
    }
  },
  error => {
    if (error.response&&error.response.data&&error.response.data.hasOwnProperty('msg')) {
      Toast.fail(error.response.data.msg);
    }

    return Promise.reject(error.response.data || {})
  }
)

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function getAxios(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.get(`${url}`, {
      params: params,
      // headers: {'token':token_list}
    })
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err)
      })
  })
}
/**
 * 封装get方法下载文件流
 * @param url
 * @param data
 * @returns {Promise}
 */
export function getFileAxios(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.get(`${url}`, {
      params: params,
      responseType: "blob",
      // headers: {'token':token}
    })
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function postAixos(url, data = {}) {
  return new Promise((resolve, reject) => {
    console.log(`${url}`);
    axios.post(`${url}`, data)
      .then(response => {
        resolve(response.data || {});
      }, err => {
        reject(err)
      })
  })
}

/**
 * 封装delete请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function deleteAixos(url) {
  return new Promise((resolve, reject) => {
    axios.delete(`${url}`)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err)
      })
  })
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function patchAxios(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.patch(`${url}`, data)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err)
      })
  })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function putAxios(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(`${url}`, data)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err)
      })
  })
}



// WEBPACK FOOTER //
// ./src/request/request.js